module.exports = __webpack_public_path__ + "static/lumpia-182384ea850a2215dba201deb892899a.jpg";